import { Box, Chip, FormControl, InputLabel, MenuItem, Select, Typography, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'

const renderContextLabel = context => {
  switch (context) {
    case 'dealStatus':
      return 'Deal Status'
    case 'status':
      return 'Status'
    case 'ncoStatus':
      return 'NCO Status'
    case 'stage':
    case 'dealStage':
      return 'Stage'
    case 'type':
      return 'Type'
    case 'billingStatus':
      return 'Billing Status'
    case 'productName':
      return 'Service Name'
    case 'product_type':
      return 'Service Line'
    case 'onboardingStatus':
      return 'Onboarding Status'
    case 'masterStatus':
      return 'Master Status'
    case 'taskType':
      return 'Task Type'
    case 'seoTier':
      return 'SEO Tier'
    default:
      return context
  }
}

const CustomStatusFilter = ({
  options,
  setterFn,
  filterModel,
  value,
  onChange,
  context,
  label,
}: {
  options: any
  setterFn: any
  filterModel: any
  value: any
  onChange: any
  context: any
  label?: any
}) => {
  const theme = useTheme()
  const [selectedValues, setSelectedValues] = useState([])

  useEffect(() => {
    const currentFilter = filterModel?.items?.find(item => item.field === context)

    if (!currentFilter) return setSelectedValues([])

    if (currentFilter.operator === 'notAnyOf') return setSelectedValues([])

    const v = currentFilter.value
    setSelectedValues(Array.isArray(v) ? v : v ? [v] : [])
  }, [filterModel, context])

  const handleStatusChange = event => {
    const raw = event.target.value
    const next = Array.isArray(raw) ? raw : typeof raw === 'string' ? raw.split(',') : []

    const selectedOptions = next.filter(Boolean)
    setSelectedValues(selectedOptions)
    setterFn(selectedOptions)
    onChange(context, selectedOptions.length > 0 ? selectedOptions : null)
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: 200,
        height: 'auto',
        minHeight: 50,
      }}
    >
      <FormControl sx={{ display: 'flex' }} fullWidth>
        <InputLabel id={`${context}-select-label`} shrink={true}>
          {renderContextLabel(context)}
        </InputLabel>
        <Select
          sx={{ height: 30, pt: 2.5, pb: 2.5, borderRadius: '4px' }}
          name={context || ''}
          label={renderContextLabel(context) || ''}
          labelId={`${context}-select-label`}
          id={`${context}-select`}
          multiple
          value={selectedValues}
          onChange={handleStatusChange}
          displayEmpty
          renderValue={selected => {
            const arr = Array.isArray(selected) ? selected : selected == null ? [] : [selected]

            return arr.length === 0 ? (
              <Typography key="default-value" sx={{ color: theme.palette.text.secondary }}>
                —
              </Typography>
            ) : (
              <Box display="flex" flexWrap="wrap" gap={1}>
                {arr.map((value, index) => {
                  const option = options.find(opt => opt.value === value)
                  return (
                    <Chip
                      key={`${index}-${value}`}
                      size="small"
                      style={{
                        backgroundColor: context === 'type' ? '' : option?.color || 'gray',
                        border: context === 'type' ? `2px solid ${option?.color}` : '',
                        color: '#fff',
                        width: 14,
                        height: 14,
                      }}
                    />
                  )
                })}
              </Box>
            )
          }}
        >
          {options.map(status => (
            <MenuItem key={`${status?.color}-${status.value}`} value={status.value}>
              <Chip
                size="small"
                style={{
                  backgroundColor: context === 'type' ? '' : status.color,
                  border: context === 'type' ? `2px solid ${status.color}` : '',
                  width: 14,
                  height: 14,
                  borderRadius: '50%',
                  margin: '5px',
                }}
              />
              <Typography variant="subtitle1" ml={1}>
                {status.label}
              </Typography>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default CustomStatusFilter
